
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";

import api from "@/api";
import { CreateOrEditCardDto, CreateOrEditCardSkuDto } from "@/api/appService";
import { ElForm } from "element-ui/types/form";

const validatePrice = (rule: any, value: number, callback: Function) => {
  if (value <= 0) {
    callback(new Error("价格不能为0"));
  } else {
    callback();
  }
};

@Component
export default class EditCard extends Vue {
  @Ref() readonly dataForm!: ElForm;

  cards: any[] = [];

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      await api.cardSku
        .getForEdit({ id: this.form!.id, cardId: this.form!.cardId })
        .then(res => {
          this.form = res.data;
          if (!this.form!.id) {
            this.form!.status = 1; //新建时启用
          }
          this.cards = (res.schema as any).cards;
        });
    } else {
      this.form = { ...this.defaultData };
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  pickerOptions = {};

  defaultData: CreateOrEditCardSkuDto = {
    title: undefined,
    status: undefined,
    originPrice: undefined,
    price: undefined,
    desc: undefined,
    durationMonth: undefined,
    cardId: undefined,
    id: 0
  };

  show = false;
  form: CreateOrEditCardSkuDto | undefined = { ...this.defaultData };

  get cardSkuDialogTitle() {
    if (this.form!.id) {
      return "编辑会员卡规格";
    } else {
      return "新建会员卡规格";
    }
  }

  async save() {
    console.log(this.form);
    this.dataForm.validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.id) {
          await api.cardSku.update({ body: this.form });
        } else {
          await api.cardSku.create({ body: this.form });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.$emit("onSave");
      }
    });
  }

  cancel() {
    this.show = false;
  }

  roleRule = {
    cardId: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    title: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    status: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    originPrice: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      },
      { type: "number", message: "必须为数字值" }
      // { validate: validatePrice, trigger: "blur" }
    ],
    price: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      },
      { type: "number", message: "必须为数字值" }
    ],
    desc: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    durationMonth: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ]
  };
}
